import Cookies from 'universal-cookie';

interface ISetOptions {
  path?: string;
  expires?: Date;
  maxAge?: number;
  domain?: string;
  secure?: boolean;
  sameSite?: any;
}

interface IGetOptions {
  doNotParse?: boolean;
}

const useTokenManagement = () => {
  const cookies = new Cookies();

  const setToken = (key: string, token: string, options?: ISetOptions): void => {
    cookies.set(key, token, { ...{ path: '/' }, ...options });
  };

  const getToken = (key: string, options?: IGetOptions): string => {
    return cookies.get(key, options);
  };

  const removeToken = (key: string, options?: ISetOptions): void => {
    cookies.remove(key, options);
  };

  return { setToken, getToken, removeToken };
};

export default useTokenManagement;
